export const CustomFunctionPaths = {
    functionDetail: ":functionId",
} as const;

export const NEW_FUNCTION_ID = "new";

export const NEW_FUNCTION_QUERY_PARAMS = {
    name: "name",
} as const;
